import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin({
    name: 'ant-design-plugin',
    enforce: 'pre',
    setup(nuxtApp) {

        nuxtApp.provide('message', message)
    }

})